// 글로벌 에러 바운더리: 한 카드 깨짐이 전 화면 white screen으로 번지지 않게.
import { Component, type ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type Props = { children: ReactNode; fallback?: ReactNode }
type State = { error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: { componentStack: string | null }) {
    // Cloudflare Workers tail / console에 컴포넌트 스택 남기기 (prod에선 Sentry/Logpush 대상).
    // 사용자에게 stack 노출 금지 — UI는 일반 메시지만 표시.
    console.error('[ErrorBoundary]', error.message, info.componentStack)
  }

  reset = () => this.setState({ error: null })

  render() {
    if (!this.state.error) return this.props.children
    if (this.props.fallback) return this.props.fallback
    return (
      <main className="container" style={{ padding: '4rem 1rem', textAlign: 'center' }}>
        <FontAwesomeIcon icon="triangle-exclamation" style={{ fontSize: '2rem', color: 'var(--color-warn, #d97706)' }} />
        <h1 style={{ marginTop: '1rem' }}>일시적 오류가 발생했습니다</h1>
        <p className="muted">새로고침하거나 잠시 후 다시 시도해주세요. 계속되면 관리자에게 문의해주세요.</p>
        <button
          type="button"
          onClick={this.reset}
          style={{
            marginTop: '1.5rem',
            padding: '0.7rem 1.4rem',
            borderRadius: 'var(--radius-pill)',
            border: '1px solid var(--color-line)',
            background: 'transparent',
            cursor: 'pointer',
          }}
        >
          <FontAwesomeIcon icon="rotate" /> 다시 시도
        </button>
      </main>
    )
  }
}
